<template>
  <div class="domaine-activite-container">
    <div class="header flex-row-space-evenly">
      <h1>Domaines d'activité</h1>
      <img src="../../img/domaine_activite/triangle.svg" alt="" class="triangle">
      <img src="../../img/domaine_activite/petits_points.svg" alt="" class="petits-points">
    </div>

    <div class="infos-container flex-row-space-evenly-wrap">
      <div class="element flex-row-space-evenly">
        <div class="image" @click="changeTo('domaine')">
          <img src="../../img/domaine_activite/icon_telecommunication.svg" class="first" alt="">
          <img src="../../img/domaine_activite/icon_vert_telecommunication.svg" class="last" alt="">
        </div>
        <div class="space"></div>
        <div class="texte flex-column">
          <h2>Télécommunications</h2>
          <p>Déploiement des infrastructures <br>fibre optique.</p>
          <p>Réseaux mobiles 3/4/5G.</p>
          <p>Connectivité nomade.</p>
          <p>Solutions de mobilité.</p>
          <p>Convergence numérique.</p>
        </div>
      </div>

      <div class="element flex-row-space-evenly">
        <div class="image" @click="changeTo('domaine-transport')">
          <img src="../../img/domaine_activite/icon_transport.svg" class="first" alt="">
          <img src="../../img/domaine_activite/icon_vert_transport.svg" class="last" alt="">
        </div>
        <div class="space"></div>
        <div class="texte flex-column">
          <h2>Transports</h2>
          <p>Réseaux de transport urbain.</p>
          <p>Infrastructures ferroviaires.</p>
          <p>Aéronautique.</p>
          <p>Transport maritime.</p>
        </div>
      </div>

      <div class="element flex-row-space-evenly">
        <div class="image" @click="changeTo('domaine-cfcf')">
          <img src="../../img/domaine_activite/icon_courant_fort_faible.svg" class="first" alt="">
          <img src="../../img/domaine_activite/icon_vert_courant_fort_faible.svg" class="last" alt="">
        </div>
        <div class="space"></div>
        <div class="texte flex-column">
          <h2>Courant fort / Courant faible</h2>
          <p>Conception, implémentation,</p>
          <p>intégration de réseaux et</p>
          <p>systèmes électriques et électroniques.</p>
        </div>
      </div>

      <div class="element flex-row-space-evenly">
        <div class="image" @click="changeTo('domaine-securite')">
          <img src="../../img/domaine_activite/icon_securite_incendie.svg" class="first" alt="">
          <img src="../../img/domaine_activite/icon_vert_securite_incendie.svg" class="last" alt="">
        </div>
        <div class="space"></div>
        <div class="texte flex-column">
          <h2>Sécurité incendie</h2>
          <p>Systèmes de détection incendie.</p>
          <p>Systèmes de mise en sécurité incendie.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {menuBus} from "../../main";

  export default {

      methods: {
          changeTo(pageName) {
              menuBus.$emit('changePage', pageName);
          }
      },
      mounted() {
          menuBus.$on('changePage', (pageName, idName) => {
              this.menuShowed = false;
          });
      }
  }
</script>

<style scoped>
  .domaine-activite-container {
    width: 100%;
    background-color: #f1f2f6;
    overflow-x: hidden;
    padding-bottom: 100px;
  }
  .domaine-activite-container > * {
    width: 100%;
  }

  .header {
    height: 230px;
    position: relative;
  }
  .infos-container {
    height: 85%;
    padding: 50px 0;
    align-items: flex-start!important;
    padding-left: 2%;
  }

  .header h1 {
    text-transform: uppercase;
    font-weight: 900;
    color: #162139;
    font-size: 60px;
    margin-top: 70px;
  }
  .header .triangle {
    position: absolute;
    bottom: 0;
    height: 30px;
  }
  .header .petits-points {
    position: absolute;
    right: 0;
    top: -50px;
    height: 150px;
  }

  .image {
    height: 130px;
    width: 130px;
    margin-right: 10px;

    position: relative;

    cursor: pointer;
  }
  .image img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
  .image img.last {
    opacity: 0;
    -webkit-transition: opacity 0.5s;
    -moz-transition: opacity 0.5s;
    -o-transition: opacity 0.5s;
    transition: opacity 0.5s;
  }
  .image img.first {
    -webkit-transition: opacity 0.5s;
    -moz-transition: opacity 0.5s;
    -o-transition: opacity 0.5s;
    transition: opacity 0.5s;
  }
  .element:hover img.first {
    opacity: 0;
  }
  .element:hover img.last {
    opacity: 1;
  }

  .element {
    width: 40%;
    min-width: 530px;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 30px 0;
  }
  .element img {
    height: 130px;
  }

  .element:hover img {
    animation: rotation-effect 0.5s;
  }
  @-webkit-keyframes rotation-effect {
    50%   { transform: rotate(20deg); }
  }
  @-moz-keyframes rotation-effect {
    50%   { transform: rotate(20deg); }
  }
  @-o-keyframes rotation-effect {
    50%   { transform: rotate(20deg); }
  }
  @keyframes rotation-effect {
    50%   { transform: rotate(20deg); }
  }

  .element .space {
    width: 20px;
  }
  .element .texte {
    width: calc(85% - 20px);
    align-items: flex-start;
  }
  .element .texte * {
    text-align: left;
    margin: 0;
  }
  .element .texte h2 {
    width: 100%;
    font-weight: 900;
    margin: 10px 0 20px 0;
    font-size: 40px;
    color: #162139;
  }
  .element .texte p {
    color: #9fa8bd;
    font-size: 20px;
    font-weight: normal;
    line-height: 1.5;
  }

  @media (max-width: 1200px) {
    .header {
      display: none;
    }
    .infos-container {
      height: auto;
    }
    .element {
      width: calc(100% - 60px);
    }
    h2 {
      font-size: 20px;
      overflow-wrap: anywhere;
    }
    p {
      font-size: 16px;
    }
    .element img {
      height: 100px;
    }
    .domaine-activite-container {
      padding-bottom: 50px;
    }
  }

  @media (max-width: 500px) {
    .element {
      width: calc(100% - 60px);
      min-width: initial;
    }
    h2 {
      font-size: 30px!important;
      overflow-wrap: anywhere;
    }
    p {
      font-size: 16px!important;
    }
    .element img {
      height: 70px;
    }
    .domaine-activite-container {
      padding-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accueil/DomaineActivite.vue